// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.hour-range-filter__shift[data-v-d338159c] {\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #6b7280;\n    font-size: 11px;\n    font-weight: 600;\n}\n.hour-range-filter__hour[data-v-d338159c] {\n    padding-left: 8px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
